import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { HttpResponseAPI } from 'src/app/models/httpResponse';
import { TurnoNoInformado } from 'src/app/models/turnos';
import { TurnosService } from 'src/app/services/turnos.service';

@Component({
    selector: 'app-turno-no-informado-modal',
    templateUrl: './turno-no-informado-modal.component.html',
    styleUrls: ['./turno-no-informado-modal.component.scss'],
})
export class TurnoNoInformadoModalComponent implements OnInit {
    turnoForm: FormGroup;

    options = [
        'No inicié el turno',
        'No finalicé el turno',
        'No inicié ni finalicé el turno',
    ];

    constructor(
        private modalCtrl: ModalController,
        private formBuilder: FormBuilder,
        private turnosService: TurnosService
    ) {}

    ngOnInit() {
        this.turnoForm = this.formBuilder.group({
            selectedOption: ['', Validators.required]
        });
    }

    dismiss() {
        this.modalCtrl.dismiss();
    }

    submit() {
        if (this.turnoForm.valid) {
            let turnoNoInformado: TurnoNoInformado = this.turnosService.crearTurnoNoInformado(this.turnoForm.value.selectedOption);

            // Informar del turno no finalizado.
            this.turnosService.turnoNoInformado(turnoNoInformado)
              .subscribe({
                next: (resultado: HttpResponseAPI) => {},
                complete: () => this.modalCtrl.dismiss()
              });
        }
    }
}
